﻿import React, { useState, useEffect } from 'react';
import { HplcDetectorType } from '../models/enums';
import { HplcBenchSheetDetector } from '../models/hplc-bench-sheet-detector';
import { LookupItem } from '../models/lookup-item';
import HplcInstrumentType1Component from './HplcInstrumentType1Component';
import HplcInstrumentType2Component from './HplcInstrumentType2Component';
import { HplcDetector } from '../models/hplc-detector';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import { Button } from 'devextreme-react/button';
import { SelectBox } from 'devextreme-react';

let key = 1;

export interface Props {
    benchSheetId: string;
    isReadOnly?: boolean;
    instrumentId?: string;
}

export default function HplcDetectorComponent(props: Props) {
    const [detectors, setDetectors] =
        useState<HplcDetector[]>();

    const [detectorList, setDetectorList] =
        useState<LookupItem[]>();

    const [selectedNewDetector, setSelectedNewDetector] =
        useState<LookupItem>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    useEffect(() => {
        getDetectorList();
    }, [props.instrumentId]);

    key++;

    const uvDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.UV) : null;

    const ridDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.RID) : null;

        /*
    const vwdDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.VWD) : null;

    const dadDetectorBase = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.DAD) : null;

    const dadDetector = (dadDetectorBase as HplcDetectorType2);

    const elsdDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.ELSD) : null;

    const ridDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.RID) : null;

    const msDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.MS) : null;

    const qqqDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.QQQ) : null;

    const qtofDetector = detectors ? detectors.find(d =>
        d.detectorType && d.detectorType.id === HplcDetectorType.QTOF) : null;
        */

    return (
        <div>
            <div className="lq-header pw-margin-top-05 aurum-blue-bg">
                <div className="lq-header-title">Detectors</div>
                <div className="title-bar-spacer" />

                <div className="save-toolbar">
                    <SelectBox dataSource={detectorList ?
                        detectorList : []} readOnly={props.isReadOnly}
                        valueExpr="id" displayExpr="name"
                        className="pw-section-right-margin-1"
                        onValueChanged={selectedNewDetectorChanged}
                        value={selectedNewDetector ? selectedNewDetector.id : undefined} />

                    <Button id="onAddDetectorButton" text="" icon="plus" type="normal"
                        hint="add new detector" disabled={props.isReadOnly}
                        height={'2.6em'}
                        onClick={onAddDetector} />
                </div>
            </div>

            {!detectors &&
                <div className="pw-form-empty-data pw-margin-bottom-1">
                    <span className="pw-form-empty-data-text">No detectors defined</span>
                </div>
            }

            <div className="pw-margin-top-05">
                {uvDetector &&
                    <div>
                        <HplcInstrumentType2Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={uvDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {ridDetector &&
                    <div>
                        <HplcInstrumentType1Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={ridDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }

                {/*

                {vwdDetector &&
                    <div>
                        <HplcInstrumentType1Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={vwdDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {dadDetector &&
                    <div>
                        <HplcInstrumentType2Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={dadDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {elsdDetector &&
                    <div>
                        <HplcInstrumentType1Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={elsdDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {ridDetector &&
                    <div>
                        <HplcInstrumentType1Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={ridDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {msDetector &&
                    <div>
                        <HplcInstrumentType3Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={msDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {qqqDetector &&
                    <div>
                        <HplcInstrumentType3Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={qqqDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                {qtofDetector &&
                    <div>
                        <HplcInstrumentType3Component isReadOnly={props.isReadOnly}
                            hplcBenchSheetDetectorId={qtofDetector.hplcBenchSheetDetectorId}
                            onDetectorDeleted={onDetectorDeleted} />
                    </div>
                }
                */}
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onDetectorDeleted() {
        getDetectors();
    }

    function selectedNewDetectorChanged(e: any) {
        if (e.value && detectorList) {
            const matchingDetector = detectorList.find(d => d.id === e.value);

            setSelectedNewDetector(matchingDetector);
        }
    }

    function onAddDetector() {
        if (!selectedNewDetector) {
            showInformationMessage(ModalMessageType.Information, "HPLC Detector", "Please select a detector from the list before adding.");
            return;
        }

        if (isDetectorAlreadyAdded(selectedNewDetector.id) === true) {
            showInformationMessage(ModalMessageType.Information, "HPLC Detector", "That detector type has already been selected.");
            return;
        }

        const detector: HplcBenchSheetDetector = {
            benchSheetId: props.benchSheetId,
            detectorTypeId: selectedNewDetector.id
        };

        insertDetector(detector)
            .then(() => {
                getDetectors();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Detector");
            });
    }

    async function getDetectors() {
        await CrudFunctions.getData(`benchsheets/hplcbenchsheetdetectors/${props.benchSheetId}`)
            .then(data => {
                setDetectors(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Detectors");
            });
    }

    async function getDetectorList() {
        if (!props.instrumentId)
            return;

        await CrudFunctions.getData(`benchsheets/hplcbenchsheetdetectorlist/${props.instrumentId}`)
            .then(data => {
                setDetectorList(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Instrument Detector List");
            });
    }

    //POST functions

    async function insertDetector(detector: HplcBenchSheetDetector) {
        return CrudFunctions.postData("benchsheets/hplcbenchsheetdetector", detector);
    }

    // other functions

    function isDetectorAlreadyAdded(detectorType: HplcDetectorType) {
        if (detectors) {
            const matchingDetectorType = detectors.find(d => d.detectorType && d.detectorType.id === detectorType);

            if (matchingDetectorType)
                return true;

            return false;
        }

        return false;
    }

    async function getAllData() {
        getDetectors();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showInformationMessage(mode: ModalMessageType, title: string, message: string) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}